import { FormattingRules } from './types';

export const FORMATTING_RULES: FormattingRules = {
  keywords: ['TASK', 'RESEARCH', 'PAGE', 'IMAGE', 'TITLE', 'DESCRIPTION', 'TYPE', 'STYLE', 'SIZE', 'GOALID', 'PROJECTID'],
  maxRecommendations: 1,
  stopInstructions: [
    'For tasks: NEVER add content after GOALID - STOP immediately',
    'For research: NEVER add content after GOALID - STOP immediately',
    'For pages: NEVER add content after PROJECTID - STOP immediately',
    'For images: NEVER add content after PROJECTID - STOP immediately'
  ],
  forbiddenPatterns: [
    'PAGE CONTENT:',
    'IMAGE CONTENT:',
    'content sections',
    'body text',
    'additional fields'
  ],
  generalRules: [
    'Use exact keywords: TASK, RESEARCH, PAGE, IMAGE, TITLE, DESCRIPTION, TYPE, STYLE, SIZE, GOALID, PROJECTID',
    'Provide only ONE recommendation total - choose the most relevant type',
    'Leave blank lines between different recommendation types',
    'IMPORTANT: Only provide ONE recommendation per response, not multiple',
    'Select appropriate GOALID for tasks/research and PROJECTID for pages/images from the available options in project context',
    'Only use this format if you genuinely believe the user wants specific recommendations'
  ]
};

export function buildFormattingRulesText(): string {
  const { stopInstructions, forbiddenPatterns, generalRules } = FORMATTING_RULES;
  
  return `
FORMATTING RULES:
${generalRules.map(rule => `- ${rule}`).join('\n')}
${stopInstructions.map(rule => `- ${rule}`).join('\n')}
- FORBIDDEN: ${forbiddenPatterns.join(', ')}

Only use this format if you genuinely believe the user wants specific recommendations.`;
} 